import React, { useState } from 'react'
import { Autocomplete, Paper, TextField } from '@mui/material'

interface Option {
    label: string
    value: string
  }

interface MultiSelectDropdownProps {
  options: Option[]
  onChange: (newValue: string[]) => void
  value: string[],
  label: string,
  limitTags: number,
  maxLength: number
}

const MultiSelectDropdown = ({ options, onChange, value, label, limitTags, maxLength }: MultiSelectDropdownProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const hasLongValue = options.filter(opt => value.includes(opt.value)).some(opt => opt.value.length > maxLength);
  const limitTagsValue = hasLongValue ? 1 : limitTags;

    return (
        <Autocomplete
            multiple
            sx={{ 
              width: '100%', 
              backgroundColor: '#fff',
              '& .MuiFormControl-root':{
                      background: 'none',
              },
            }}
            options={options.sort((a, b) => a.label.localeCompare(b.label))}
            limitTags={limitTagsValue}
            value={options.filter(opt => value.includes(opt.value))}
            getOptionLabel={(option) => option.label}
            onChange={(event, newValue) => onChange(newValue.map(opt => opt.value))}
            renderInput={(params) => (
            <TextField
                {...params}
                label={value.length === 0 && !isFocused ? label : ''}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                InputLabelProps={{
                    shrink: false,
                    sx: {
                      '&.Mui-focused': {
                        color: '#9135E0',
                      },
                      fontSize: '20px',
                      fontFamily: 'InterRegular',
                    },
                    
                  }}
                sx={{
                    '& .MuiOutlinedInput-root': {
                    minHeight: '50px',
                    height: 'auto',
                    '&:hover fieldset': {
                    borderColor: '#A0A0A4',
                    },
                    '&.Mui-focused fieldset': {
                    borderColor: '#9135E0',
                    fontSize: '20px',
                    },
                    '&.MuiInputBase-root':{
                        backgroundColor: '#fff !important',
                        border: 'none',
                    },
                },
                }}

            />
            )}
            ChipProps={{
                sx: {
                    fontSize: '16px',
                    fontFamily: 'InterRegular',
                    textTransform: 'capitalize',
                    marginTop: '8px !important',
                },
                size: 'small',
            }}
            PaperComponent={(props) => (
                <Paper {...props} sx={{ fontSize: '18px !important'}} />
            )}
            ListboxProps={{
              style: {
                  maxHeight: '300px',
                  overflow: 'auto',
                  textTransform: 'capitalize'
              }
          }}
        />
    )
}
export default MultiSelectDropdown